module.exports = __webpack_public_path__ + "static/img/CZ.ab5a15f5.jpg";